import React from 'react';
import { useSelector } from 'react-redux';
import { useState } from "react";
import useSnackbar from '../../../hooks/useSnackbar';
import { getTransactionCurrencyRevRounding, getTransactionCurrencyRevOtherAccounts,
  getTransactionCurrencyRevOpenPayables, getTransactionCurrencyRevOpenReceivables,
  getTransactionCurrencyRevRealizedGainLoss,
  
} from "../../../api/transaction-type";
import { currencyRevaluationRealizedGainLossTable, currencyRevaluationOpenReceivablesTable,
  currencyRevaluationOtherAccountsTable, currencyRevaluationRoundingTable
} from '../../../config/grid-column-defs';
import AgGridPaginatedTable from '../../../components/AgGridPaginatedTable';
import { slugMap } from '../../../config/slug-config';
import { useParams } from 'react-router-dom';
import { Box, Tabs, Tab, CircularProgress } from '@mui/material';
import TabPanel from "../../../components/TabPanel";

export default function CurrencyRevaluationDetails({ rowData }) {

  const snackbar = useSnackbar();
  const { data: user } = useSelector(state => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const pageDetail = slugMap[params.slug];

  const [subTabScreen1Index, setSubTabScreen1Index] = useState(0);
  const [subTabScreen2Index, setSubTabScreen2Index] = useState(0);
  const [subTabScreen3Index, setSubTabScreen3Index] = useState(0);
  const [subTabScreen4Index, setSubTabScreen4Index] = useState(0);

  const [realizedGainLossAmountSum, setRealizedGainLossAmountSum] = useState("");
  const [openReceivablesAmountSum, setOpenReceivablesAmountSum] = useState("");
  const [openPayablesAmountSum, setOpenPayablesAmountSum] = useState("");
  const [otherAccountsAmountSum, setOtherAccountsAmountSum] = useState("");
  const [roundingAmountSum, setRoundingAmountSum] = useState("");

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {  
  //     setTableRefreshCount(prev => prev + 1);
  // }

  async function getTransactionCurrencyRevRealizedGainLossData(limit, offset) {
    try {
      const { data } = await getTransactionCurrencyRevRealizedGainLoss(user.token, { id: params.docNo, limit, offset });
      setRealizedGainLossAmountSum(data.data.amountSum);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true }
    } finally {
      // setLoading(false);
    }
  }

  async function getTransactionCurrencyRevOpenReceivablesData(limit, offset) {
    try {
      const { data } = await getTransactionCurrencyRevOpenReceivables(user.token, { id: params.docNo, limit, offset });
      setOpenReceivablesAmountSum(data.data.amountSum);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true }
    } finally {
      // setLoading(false);
    }
  }

  async function getTransactionCurrencyRevOpenPayablesData(limit, offset) {
    try {
      const { data } = await getTransactionCurrencyRevOpenPayables(user.token, { id: params.docNo, limit, offset });
      setOpenPayablesAmountSum(data.data.amountSum);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true }
    } finally {
      // setLoading(false);
    }
  }

  async function getTransactionCurrencyRevOtherAccountsData(limit, offset) {
    try {
      const { data } = await getTransactionCurrencyRevOtherAccounts(user.token, { id: params.docNo, limit, offset });
      setOtherAccountsAmountSum(data.data.amountSum);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true }
    } finally {
      // setLoading(false);
    }
  }

  async function getTransactionCurrencyRevRoundingData(limit, offset) {
    try {
      const { data } = await getTransactionCurrencyRevRounding(user.token, { id: params.docNo, limit, offset });
      setRoundingAmountSum(data.data.amountSum);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true }
    } finally {
      // setLoading(false);
    }
  }

  return (
    <Box className="sub-tab" sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: '#fff' }}>
      {rowData.map((d, i) => (
        <>
          {d.account === "83005 Realized Exchange Loss (Gain)" ? (
            <>
              {/* Realized Gain/Loss */}
              <Tabs
                value={subTabScreen1Index}
                // onChange={handleChange}
                onChange={(e, snv) => {
                  setSubTabScreen1Index(snv);
                }}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
                className="tabs-bkg1"
              >
                {/* <Tab label={`Realized Gain/Loss ${realizedGainLossAmountSum}`} /> */}
                <Tab label="Realized Gain/Loss" />
              </Tabs>

              <TabPanel value={subTabScreen1Index} index={0}>
                <AgGridPaginatedTable getTableRows={getTransactionCurrencyRevRealizedGainLossData}
                  columns={currencyRevaluationRealizedGainLossTable} perPage={5} refreshCounter={0}
                />
              </TabPanel>
              {/* Realized Gain/Loss */}
            </>
          ) :
            d.account === "83030 Unrealized Matching Gain/Loss" ? (
              <>
                {/* Other Accounts */}
                <Tabs
                  value={subTabScreen2Index}
                  // onChange={handleChange}
                  onChange={(e, snv) => {
                    setSubTabScreen2Index(snv);
                  }}
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="scrollable auto tabs example"
                  className="tabs-bkg1"
                >
                  {/* <Tab label={`Other Accounts ${otherAccountsAmountSum}`} /> */}
                  <Tab label="Other Accounts" />
                </Tabs>

                <TabPanel value={subTabScreen2Index} index={0}>
                  <AgGridPaginatedTable getTableRows={getTransactionCurrencyRevOtherAccountsData}
                    columns={currencyRevaluationOtherAccountsTable} perPage={5} refreshCounter={0}
                  />
                </TabPanel>
                {/* Other Accounts */}
              </>
            ) :
              d.account === "83900 Foreign Exchange Loss (Gain) : Rounding Gain/Loss" ? (
                <>
                  {/* Rounding */}
                  <Tabs
                    value={subTabScreen3Index}
                    // onChange={handleChange}
                    onChange={(e, snv) => {
                      setSubTabScreen3Index(snv);
                    }}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                    className="tabs-bkg1"
                  >
                     {/* <Tab label={`Rounding ${roundingAmountSum}`} />  */}
                     <Tab label="Rounding" /> 
                  </Tabs>

                  <TabPanel value={subTabScreen3Index} index={0}>
                    <AgGridPaginatedTable getTableRows={getTransactionCurrencyRevRoundingData}
                      columns={currencyRevaluationRoundingTable} perPage={5} refreshCounter={0}
                    />
                  </TabPanel>
                  {/* Rounding */}
                </>
              ) :
                d.account === "83011 Unrealized Gain/Loss" ? (
                  <>
                    {/* Open Receivables, Open Payables, Other Accounts */}
                    <Tabs
                      value={subTabScreen4Index}
                      // onChange={handleChange}
                      onChange={(e, snv) => {
                        setSubTabScreen4Index(snv);
                      }}
                      variant="scrollable"
                      scrollButtons="auto"
                      aria-label="scrollable auto tabs example"
                      className="tabs-bkg1"
                    >
                      {/* <Tab label={`Open Receivables ${openReceivablesAmountSum}`} />
                      <Tab label={`Open Payables ${openPayablesAmountSum}`} />
                      <Tab label={`Other Accounts ${otherAccountsAmountSum}`} /> */}

                      <Tab label="Open Receivables" />
                      <Tab label="Open Payables" />
                      <Tab label="Other Accounts" />
                  
                    </Tabs>

                    <TabPanel value={subTabScreen4Index} index={0}>
                      <AgGridPaginatedTable getTableRows={getTransactionCurrencyRevOpenReceivablesData}
                        columns={currencyRevaluationOpenReceivablesTable} perPage={5} refreshCounter={0}
                      />
                    </TabPanel>

                    <TabPanel value={subTabScreen4Index} index={1}>
                      <AgGridPaginatedTable getTableRows={getTransactionCurrencyRevOpenPayablesData}
                        columns={currencyRevaluationOpenReceivablesTable} perPage={5} refreshCounter={0}
                      />
                    </TabPanel>

                    <TabPanel value={subTabScreen4Index} index={2}>
                      <AgGridPaginatedTable getTableRows={getTransactionCurrencyRevOtherAccountsData}
                        columns={currencyRevaluationOtherAccountsTable} perPage={5} refreshCounter={0}
                      />
                    </TabPanel>
                    {/* Open Receivables, Open Payables, Other Accounts */}
                  </>
                ) :
                  (<></>)}
        </>
      ))}
    </Box>
  )
}





